<section class="sh-dialog__content">
    <ng-container *ngIf="complexFieldDefinition.Children as childFields">
        <dl class="sh-description-list sh-clear-margin">
            <ng-container *ngFor="let childField of childFields">
                <ng-container
                    *ngIf="isSimpleType(childField)"
                    [ngTemplateOutlet]="simpleField"
                    [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
                >
                </ng-container>
                <ng-container
                    *ngIf="isListType(childField)"
                    [ngTemplateOutlet]="listField"
                    [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
                >
                </ng-container>

                <ng-container
                    *ngIf="isMapType(childField)"
                    [ngTemplateOutlet]="mapField"
                    [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
                >
                </ng-container>

                <ng-container
                    *ngIf="isComplexListType(childField)"
                    [ngTemplateOutlet]="complexListField"
                    [ngTemplateOutletContext]="{fieldDefinition: childField, value: complexValue}"
                >
                </ng-container>
            </ng-container>
        </dl>
    </ng-container>
</section>

<ng-template #simpleField let-fieldDefinition="fieldDefinition" let-value="value">
    <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
    <dd class="sh-description-list__details">{{ getSimpleValue(fieldDefinition, value) }}</dd>
</ng-template>

<ng-template #listField let-fieldDefinition="fieldDefinition" let-value="value">
    <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
    <dd class="sh-description-list__details">
        <ng-container *ngIf="getListValues(fieldDefinition, value) as labels">
            <span *ngFor="let label of labels; let index = index;">
                {{ label }}
                <ng-container *ngIf="index < labels.length-1">, </ng-container>
            </span>
        </ng-container>
    </dd>
</ng-template>

<ng-template #mapField let-fieldDefinition="fieldDefinition" let-value="value">
    <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
    <dd class="sh-description-list__details">
        <sh-html-parser [message]="getMapValue(fieldDefinition, value)"></sh-html-parser>
    </dd>
</ng-template>

<ng-template #complexListField let-fieldDefinition="fieldDefinition" let-value="value">
    <dt [id]="fieldDefinition.FlatKey" class="sh-description-list__term">{{ fieldDefinition.Label }}</dt>
    <dd class="sh-description-list__details">
        <ul class="sh-label-list sh-clear-margin">
            <li *ngFor="let label of getComplexListValues(fieldDefinition, value)" class="sh-label-list__item">
                <span class="sh-label-list__item__label">
                    <sh-html-parser [message]="label"></sh-html-parser>
                </span>
            </li>
        </ul>
    </dd>
</ng-template>
